/**
 * In-memory cache for `/property/config/media` payloads per property_config_id.
 * Shared by phase + config screens to avoid duplicate requests (navigation or Strict Mode).
 */
const configMediaSessionCache = new Map();

export function getCachedConfigMediaArray(propertyConfigId) {
  if (propertyConfigId == null) return undefined;
  return configMediaSessionCache.get(String(propertyConfigId));
}

/** Stores raw API payload: new envelope object or legacy array / { items }. */
export function setCachedConfigMediaArray(propertyConfigId, payload) {
  if (propertyConfigId == null) return;
  configMediaSessionCache.set(String(propertyConfigId), payload);
}
